import { SVGFC } from '@repo/toolkit/types'

const UserFiveIcon: SVGFC = ({ color, filled = true, isIconFilled, ...props }) => {
  const isFilled = filled || isIconFilled

  if (!isFilled) {
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.9976 14.583C15.5003 14.5827 16.969 15.0458 18.2095 15.9131C19.4501 16.7805 20.4048 18.0119 20.9458 19.4453V19.4463C21.0763 19.7898 20.9638 20.1894 20.6626 20.4268H20.6616C18.8196 21.8841 16.5065 22.751 13.9956 22.751C11.5857 22.7541 9.24236 21.9386 7.3374 20.4316L7.33154 20.4277L7.23193 20.3369C7.14019 20.239 7.07175 20.1186 7.03369 19.9854C6.98303 19.8078 6.98996 19.6183 7.05322 19.4453L7.05225 19.4443C7.59286 18.0124 8.54661 16.7822 9.78564 15.915C11.0258 15.0471 12.4947 14.5834 13.9976 14.583ZM13.9956 5.25098C14.7494 5.25098 15.4749 5.55587 16.0112 6.10156C16.5479 6.64778 16.8511 7.39113 16.8511 8.16797C16.8511 8.94481 16.5479 9.68815 16.0112 10.2344C15.4749 10.7801 14.7494 11.085 13.9956 11.085C13.242 11.0849 12.5171 10.7799 11.981 10.2344C11.4443 9.68815 11.1401 8.94481 11.1401 8.16797C11.1401 7.39113 11.4443 6.64778 11.981 6.10156C12.5171 5.55603 13.242 5.25108 13.9956 5.25098Z"
          stroke={color ?? '#0F6FFF'}
          strokeWidth="1.16667"
        />
      </svg>
    )
  }
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9983 9.1665C11.7149 9.1665 12.4021 8.87677 12.9088 8.36105C13.4155 7.84532 13.7002 7.14585 13.7002 6.4165C13.7002 5.68716 13.4155 4.98768 12.9088 4.47196C12.4021 3.95624 11.7149 3.6665 10.9983 3.6665C10.2817 3.6665 9.59446 3.95624 9.08776 4.47196C8.58106 4.98768 8.2964 5.68716 8.2964 6.4165C8.2964 7.14585 8.58106 7.84532 9.08776 8.36105C9.59446 8.87677 10.2817 9.1665 10.9983 9.1665Z"
        fill={color ?? 'white'}
      />
      <path
        d="M5.11269 15.1193C5.02951 15.3465 5.02051 15.595 5.08703 15.8278C5.15354 16.0606 5.29203 16.2654 5.48194 16.4118C7.05923 17.6596 9.0006 18.3358 10.9983 18.3332C13.0787 18.3332 14.9953 17.6145 16.52 16.4082C16.9073 16.1029 17.064 15.5804 16.8875 15.1157C16.4302 13.9039 15.6226 12.8617 14.5713 12.1266C13.5201 11.3916 12.2746 10.9983 10.9991 10.9986C9.72374 10.9989 8.47839 11.3928 7.42747 12.1283C6.37655 12.8638 5.56945 13.9064 5.11269 15.1184V15.1193Z"
        fill={color ?? 'white'}
      />
      <path
        d="M10.999 11.4565C12.1799 11.4563 13.3339 11.8209 14.3086 12.5024C15.2834 13.184 16.0339 14.1515 16.459 15.2778V15.2788C16.5613 15.5486 16.4729 15.8619 16.2363 16.0483H16.2354C14.788 17.1934 12.9709 17.8745 10.998 17.8745C9.1046 17.877 7.26335 17.2363 5.7666 16.0522L5.76172 16.0483C5.65035 15.9624 5.5672 15.8412 5.52734 15.7017C5.48782 15.563 5.49318 15.415 5.54199 15.2798C5.96656 14.1534 6.71603 13.1854 7.69043 12.5034C8.6647 11.8216 9.81837 11.4569 10.999 11.4565ZM10.998 4.12451C11.5904 4.12451 12.1606 4.36456 12.582 4.79346C13.0036 5.22261 13.2422 5.80624 13.2422 6.4165C13.2422 7.02677 13.0036 7.6104 12.582 8.03955C12.1606 8.46845 11.5904 8.7085 10.998 8.7085C10.4058 8.70843 9.83638 8.46838 9.41504 8.03955C8.99338 7.61038 8.75488 7.02688 8.75488 6.4165C8.75488 5.80613 8.99338 5.22263 9.41504 4.79346C9.83638 4.36463 10.4058 4.12457 10.998 4.12451Z"
        stroke={color ?? 'white'}
        strokeWidth="0.916666"
      />
    </svg>
  )
}

export default UserFiveIcon
